import React, { useState } from 'react';

// ─── 微信 UA 检测 ────────────────────────────────────────────────────────────
// MicroMessenger 是微信 WebView 的标志性 UA 字段，覆盖 iOS / Android / Mac 微信
export const isWeChatBrowser = () =>
  /MicroMessenger/i.test(navigator.userAgent);

// ─── 微信拦截全屏遮罩 ────────────────────────────────────────────────────────
// 进入即全屏覆盖，无法关闭，引导用户从外部浏览器打开
export default function WeChatBlocker() {
  const [copied, setCopied] = useState(false);

  const url = window.location.href;

  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    } else {
      // 降级：选中并提示手动复制
      const el = document.createElement('textarea');
      el.value = url;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      try { document.execCommand('copy'); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch {}
      document.body.removeChild(el);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      background: 'linear-gradient(160deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '32px 24px', textAlign: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "PingFang SC", sans-serif',
    }}>

      {/* 图标区 */}
      <div style={{ marginBottom: 28 }}>
        {/* 微信图标（叉掉）*/}
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <svg width="72" height="72" viewBox="0 0 72 72" fill="none">
            {/* 微信气泡形状 */}
            <circle cx="36" cy="36" r="34" fill="rgba(7,193,96,0.15)" stroke="rgba(7,193,96,0.3)" strokeWidth="1.5"/>
            <text x="36" y="44" textAnchor="middle" fontSize="30" fill="rgba(7,193,96,0.6)">💬</text>
          </svg>
          {/* 禁止符号 */}
          <div style={{
            position: 'absolute', inset: -4,
            border: '3.5px solid #ff3b30',
            borderRadius: '50%',
          }} />
          <div style={{
            position: 'absolute',
            top: '50%', left: -4, right: -4,
            height: 3.5,
            background: '#ff3b30',
            transform: 'translateY(-50%) rotate(45deg)',
            transformOrigin: 'center',
            borderRadius: 2,
          }} />
        </div>
      </div>

      {/* 主标题 */}
      <div style={{
        fontSize: 22, fontWeight: 800, color: '#ffffff',
        marginBottom: 12, lineHeight: 1.3,
      }}>
        请在浏览器中打开
      </div>

      {/* 说明文字 */}
      <div style={{
        fontSize: 14, color: 'rgba(255,255,255,0.6)',
        lineHeight: 1.8, marginBottom: 32, maxWidth: 280,
      }}>
        微信内置浏览器限制了图片上传功能，<br />
        请用系统浏览器访问本网站以正常使用。
      </div>

      {/* 操作步骤卡片 */}
      <div style={{
        background: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 16, padding: '20px 20px',
        width: '100%', maxWidth: 320, marginBottom: 24,
        textAlign: 'left',
      }}>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', fontWeight: 600, marginBottom: 14, letterSpacing: '0.06em' }}>
          操作步骤
        </div>
        {[
          { icon: '···', text: '点击右上角「···」按钮' },
          { icon: '🌐', text: '选择「在浏览器中打开」' },
          { icon: '✅', text: '即可正常上传图片' },
        ].map((step, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 12,
            marginBottom: i < 2 ? 12 : 0,
          }}>
            <div style={{
              width: 32, height: 32, borderRadius: 8,
              background: 'rgba(0,122,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: step.icon === '···' ? 18 : 15,
              color: step.icon === '···' ? '#ffffff' : undefined,
              flexShrink: 0,
              fontWeight: step.icon === '···' ? 800 : undefined,
              letterSpacing: step.icon === '···' ? '-2px' : undefined,
            }}>
              {step.icon}
            </div>
            <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.8)', lineHeight: 1.4 }}>
              {step.text}
            </span>
          </div>
        ))}
      </div>

      {/* 复制链接按钮（备用：如「在浏览器打开」不出现时手动粘贴）*/}
      <button
        onClick={handleCopy}
        style={{
          width: '100%', maxWidth: 320,
          height: 48, borderRadius: 12,
          border: '1px solid rgba(255,255,255,0.2)',
          background: copied ? 'rgba(52,199,89,0.2)' : 'rgba(255,255,255,0.08)',
          color: copied ? '#34c759' : 'rgba(255,255,255,0.7)',
          fontSize: 14, fontWeight: 600, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          transition: 'all 0.2s',
        }}
      >
        {copied ? (
          <>✓ 链接已复制，请粘贴到浏览器</>
        ) : (
          <>📋 复制链接，手动在浏览器打开</>
        )}
      </button>

      {/* 右上角箭头引导图（指向微信右上角）*/}
      <div style={{
        position: 'fixed', top: 12, right: 16,
        display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4,
      }}>
        <svg width="36" height="48" viewBox="0 0 36 48" fill="none">
          <path d="M28 4 C28 4, 28 36, 4 44"
            stroke="#ff9500" strokeWidth="2.5" strokeLinecap="round"
            fill="none" strokeDasharray="4 3"/>
          <polyline points="20,4 28,4 28,14"
            stroke="#ff9500" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </svg>
        <div style={{
          fontSize: 11, color: '#ff9500', fontWeight: 700,
          background: 'rgba(255,149,0,0.15)',
          border: '1px solid rgba(255,149,0,0.3)',
          borderRadius: 6, padding: '3px 8px',
          whiteSpace: 'nowrap',
        }}>
          点这里
        </div>
      </div>

    </div>
  );
}
